// Module
var code = "<input type=\"checkbox\" ng-disabled=\"$ctrl.ngDisabled\" ng-model=\"$ctrl.ngModel\">\n<span class=\"md-switch\" ng-click=\"$ctrl.toggle()\"></span>";
// Exports
module.exports = code;